import React from "react";

import { useHistory } from "react-router-dom";

import {
  Grid,
  Icons,
  Text,
  MenuIconButton,
  MenuButton,
  PopupPosition,
} from "@pushpress/shared-components";

interface CalendarHeaderProps {
  onCreateClassClick: VoidFunction;
  onCreateAppointmentClick: VoidFunction;
  onCreateEventClick: VoidFunction;
}

const CalendarHeader = (props: CalendarHeaderProps) => {
  const { onCreateAppointmentClick, onCreateClassClick, onCreateEventClick } =
    props;

  const history = useHistory();

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Text variant="heading-3">Calendar</Text>
      </Grid>
      <Grid item>
        <Grid container alignItems="center" spacing={3}>
          <Grid item>
            <MenuIconButton
              icon={Icons.NewPage}
              align="center"
              anchorMargin={10}
              tooltip="Public Calendar"
              menuItems={[
                {
                  label: "Public / Embeddable Calendar",
                  onClick: () => (window.location.href = "/landing/calendar"),
                },
              ]}
            />
          </Grid>
          <Grid item>
            <MenuIconButton
              icon={Icons.NavIconSettings}
              align="center"
              anchorMargin={10}
              tooltip="Setup"
              menuItems={[
                {
                  label: "Class types",
                  onClick: () => history.push("/schedule/class-types"),
                },
                {
                  label: "Locations",
                  onClick: () => history.push("/locations"),
                },
              ]}
            />
          </Grid>
          <Grid item>
            <MenuButton
              align="center"
              anchorMargin={10}
              text="Create"
              size="large"
              buttonType="primary"
              icon={Icons.Plus}
              iconLocation="left"
              menuItems={[
                {
                  label: "Class",
                  onClick: onCreateClassClick,
                },
                {
                  label: "Event",
                  onClick: onCreateEventClick,
                },
                {
                  label: "Appointment",
                  onClick: onCreateAppointmentClick,
                },
              ]}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CalendarHeader;
